import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

import { useTranslations } from '@lang';
import SectionContainer from '@common/components/SectionContainer';
import { ProductGrid } from '@common/components/ProductGrid';
import { Heading4 } from '@common/components/Typography';
import { entitySelectors } from '@store/entity/selectors';

const ProductsWrapper = styled(SectionContainer)`
  margin-top: 10px;
`;

const ProductsTitle = styled(Heading4)`
  display: block;
  font-size: 22px;
  padding: 20px 0;

  ${media.md`
    font-size: 35px;
  `}
`;

export const Products = ({ property, products }) => {
  const { t } = useTranslations();

  return (
    <ProductsWrapper>
      <ProductsTitle>
        {t('products.shopProperty', {
          property: property.name,
        })}
      </ProductsTitle>
      <ProductGrid items={products} />
    </ProductsWrapper>
  );
};

Products.propTypes = {
  property: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  property: entitySelectors.getProperty(state, ownProps.id),
  products: entitySelectors.getAllProducts(state),
});

export default connect(mapStateToProps)(Products);
